// Shared query-key prefixes. Overview lives here (not inline) because both attendance and roster invalidate it.
export const overviewKeys = {
  all: ["overview"] as const,
};

// Setup keys live here (not in the feature) because attendance mutations also invalidate them.
export const setupKeys = {
  all: ["setup"] as const,
  next: ["setup", "next"] as const,
  raids: ["setup", "raids"] as const,
  byRaid: (raidId: string) => ["setup", "raid", raidId] as const,
};

// Splits keys live here because character mutations (shared) invalidate them alongside roster/overview.
export const splitsKeys = {
  all: ["splits"] as const,
};

export const patchKeys = {
  all: ["patches"] as const,
};

export const raidContentKeys = {
  all: ["raid-content"] as const,
  byDate: (date: string, raidId?: string) =>
    ["raid-content", date, raidId ?? "new"] as const,
};
